import React, { useState, useEffect } from "react";
import OtpVerify from "./OtpVerify";
import { showToast, ToastMessage } from "../../Shared/ToastMessage";
import axios from "axios";
import { Tabs, Tab, FormCheck } from "react-bootstrap";
import { Link, useHistory } from 'react-router-dom';
import Cookies from 'js-cookie';
import logo from '../../../assets/images/logo.png';
import { baseUrl, ROUTE_BASE_URL } from "../../../api/common";
import { encryptSlug } from "../../../util/encryption";

export default function UserLogin() {
  
  const history = useHistory();
  
  const [enableOtp, setEnableOtp] = useState(false);
  const [adminId, setAdminId] = useState("");
  const [email, setEmail] = useState(localStorage.getItem("rememberMemberEmail") || "");
  const [password, setPassword] = useState(localStorage.getItem("rememberMemberPassword") || "");
  const [rememberMe, setRememberMe] = useState(!!localStorage.getItem("rememberMemberEmail"));
  const [showPassword, setShowPassword] = useState(false);

  const tabKeys = ["otp", "password"];
  const [activeTab, setActiveTab] = useState(tabKeys[0]);

  useEffect(() => {
    if (rememberMe && localStorage.getItem("rememberMemberEmail")) {
      setEmail(localStorage.getItem("rememberMemberEmail"));
      setPassword(localStorage.getItem("rememberMemberPassword") || "");
    }
  }, []);

  const handleTabChange = (selectedTab) => {
    setActiveTab(selectedTab);
  };

  const handleRememberMeChange = (e) => {
    setRememberMe(e.target.checked);
  };

  const sendOtp = async () => {
    if (!email) {
      showToast("Email cannot be empty", "error");
      return;
    }
    if (activeTab === "password" && !password) {
      showToast("Password cannot be empty", "error");
      return;
    }

    try {
      const response = await axios.post(
        `${baseUrl}/api/${activeTab === "otp" ? "member_send_otp" : "memberlogin"}`,
        {
          ...(activeTab === "otp" && { email: email }),
          ...(activeTab === "password" && { username: email, password: password }),
        },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Source": "web",
            Authorization: localStorage.getItem("access_token"),
          },
        }
      );

      if (response.data.status) {
        if (activeTab === "otp") {
          setAdminId(response.data.userid);
          showToast(response.data.message, "success");
          if (rememberMe) {
            localStorage.setItem("rememberMemberEmail", email);
          } else {
            localStorage.removeItem("rememberMemberEmail");
          }
          setEnableOtp(true);
        } else {
          showToast(response.data.message, "success");
          const user = response.data.data[0];
          // Store user details
          Cookies.set("memberUserId", response.data.data[0].id, { expires: 1 });
          localStorage.setItem("loginMemberUserId", response.data.data[0].id);
          const fullName = `${user.first_name}${user.middle_name ? ' ' + user.middle_name : ''}${user.last_name ? ' ' + user.last_name : ''}`;
          localStorage.setItem('loginMemberUserName', fullName);
          localStorage.setItem("loginMemberUserImage", response.data.data[0].profile);

          // Store credentials if "Remember me" is checked
          if (rememberMe) {
            localStorage.setItem("rememberMemberEmail", email);
            localStorage.setItem("rememberMemberPassword", password);
          } else {
            localStorage.removeItem("rememberMemberEmail");
            localStorage.removeItem("rememberMemberPassword");
          }
          history.replace(`${ROUTE_BASE_URL}/user-member-application-preview/${encryptSlug(`${response.data.data[0].id}`)}`);
          // history.replace(`${ROUTE_BASE_URL}/user-member-application-list`);
        }
      } else {
        showToast(response.data.message, "error");
      }
    } catch (error) {
      console.error("Error during submission:", error);
      showToast("A network error occurred, or the server is temporarily busy. Please try again later.", "error");
    }
  };

  return (
    <>
      <ToastMessage />
      {!enableOtp ? (
        <div className="auth-main particles_js">
          <div className="auth_div vivify popIn login-width">
            <div className="auth_brand">
              <img
                src={logo}
                width="80"
                height="80"
                className="d-inline-block align-top mr-2"
                alt="amasi"
              />
            </div>
            <div className="card">
              <div className="body">
                <p className="lead">
                  <strong>AMASI User Dashboard</strong>
                </p>
                <p className="lead pb-3 fs-16">Welcome back! Please login to access your Dashboard</p>

                <div className="form-group pos_relative text-left">
                  <label>
                    Email <span className="text-danger">*</span>
                  </label>
                  <input
                    type="email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    className="form-control"
                    placeholder="Enter your Email"
                  />
                </div>

                <Tabs
                  activeKey={activeTab}
                  onSelect={handleTabChange}
                  className="mb-3 login-tabs"
                  id="login-tabs"
                >
                  <Tab eventKey="otp" title="Login with OTP">
                    <p>Enter your email and click send OTP to receive an OTP.</p>
                  </Tab>

                  <Tab eventKey="password" title="Login with Password">
                    <div className="form-group pos_relative mt-3 text-left">
                      <label>
                        Password <span className="text-danger">*</span>
                      </label>
                      <div className="input-group">
                        <input
                          type={showPassword ? "text" : "password"}
                          value={password}
                          onChange={e => setPassword(e.target.value)}
                          className="form-control"
                          placeholder="Enter your Password"
                        />
                        <div className="input-group-append">
                          <button
                            type="button"
                            className="btn btn-outline-secondary"
                            onClick={() => setShowPassword(!showPassword)}
                          >
                            {showPassword ? <i className="fa fa-eye-slash" /> : <i className="fa fa-eye" />}
                          </button>
                        </div>
                      </div>
                    </div>
                  </Tab>
                </Tabs>

                <label className="d-flex align-items-center">
                  <FormCheck
                    type="checkbox"
                    id="checkbox-permanent"
                    label="Remember me"
                    checked={rememberMe}
                    onChange={handleRememberMeChange}
                    className="login-mb-10 cursor-pointer"
                  />
                  <Link to={`${ROUTE_BASE_URL}/user-forgot-password`} className="ml-auto">Forgot Email?</Link>
                </label>
                <button onClick={sendOtp} className="btn btn-outline-primary btn-block login-mb-10">
                  {activeTab === "otp" ? "Send OTP" : "Login"}
                </button>
                <p><a target="_blank" href={`https://www.amasi.org/contact-us`}>Need help?</a> Contact support</p>
              </div>
            </div>
          </div>
          <div id="particles-js" />
        </div>
      ) : (
        <OtpVerify adminId={adminId} />
      )}
    </>
  );
}


// import React, { useState } from "react";
// import OtpVerify from "./OtpVerify";
// import { showToast, ToastMessage } from "../Shared/ToastMessage";
// import axios from "axios";
// import { baseUrl, ROUTE_BASE_URL } from "../../api/common";
// import { Tabs, Tab, FormCheck } from "react-bootstrap";
// import { Link, useHistory } from 'react-router-dom';
// import Cookies from 'js-cookie';
// import logo from '../../assets/images/logo.png';
// export default function Login() {

//   const history = useHistory();

//   const [enableOtp, setEnableOtp] = useState(false);
//   const [adminId, setAdminId] = useState("");
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");

//   const tabKeys = ["otp", "password"];
//   const [activeTab, setActiveTab] = useState(tabKeys[0]);

//   const handleTabChange = (selectedTab) => {
//     setActiveTab(selectedTab);
//   };
//   const [showPassword, setShowPassword] = useState(false);
//   const sendOtp = async () => {

//     if (!email) {
//       showToast("Email cannot be empty", "error");
//       return;
//     }

//     if (activeTab === "password" && !password) {
//       showToast("Password cannot be empty", "error");
//       return;
//     }

//     try {
//       console.log(email, "email");
//       const response = await axios.post(
//         `${baseUrl}/api/${activeTab === "otp"?"admin_send_otp":"adminlogin"}`,
//         { 
// 			// email: email,
// 			...(activeTab === "otp"&&{email:email}),
// 			...(activeTab === "password"&&{username:email,password:password})
// 		 },
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: localStorage.getItem("access_token"),
//           },
//         }
//       );
//       if (response.data.status) {
// 		if(activeTab === "otp"){
// 			setAdminId(response.data.userid);
// 			showToast(response.data.message, "success");
// 			setEnableOtp(true);
// 		}else{
// 			showToast(response.data.message, "success");
// 			Cookies.set('userId', response.data.data[0].id, { expires: 1 });
// 			localStorage.setItem('loginUserId', response.data.data[0].id);
// 			localStorage.setItem('loginUserName', response.data.data[0].full_name);
// 			localStorage.setItem('loginUserImage', response.data.data[0].profile);
// 			history.replace(`${ROUTE_BASE_URL}`);
// 		}
//       } else {
//         showToast(response.data.message, "error");
//       }
//     } catch (error) {
//       console.error("Error during submission:", error);
//       showToast("A network error occurred, or the server is temporarily busy. Please try again later.", "error");
//     }
//   };

//   return (
//     <>
//       <ToastMessage />
//       {!enableOtp ? (
// <div className="auth-main particles_js">
//   <div className="auth_div vivify popIn">
//     <div className="auth_brand">
//       <img
// 	    src={logo}
//         // src="https://cdn.prod.website-files.com/66712a83ccf4e64be43d1817/66712f8f27aaed354f88a0b7_amasi_logo.png"
//         width="80"
//         height="80"
//         className="d-inline-block align-top mr-2"
//         alt="amasi"
//       />
//     </div>
//     <div className="card">
//       <div className="body">

//         <p className="lead pb-3"><strong>AMASI Admin Dashboard</strong><br/> Welcome back! Please login to access your admin panel</p>

//         <div className="form-group pos_relative">
//           <label>
//             Username <span className="text-danger">*</span>
//           </label>
//           <input
//             type="email"
//             value={email}
//             onChange={e => setEmail (e.target.value)}
//             className="form-control"
//             placeholder="Enter your Username"
//           />
//         </div>

//         <Tabs
//           activeKey={activeTab}
//           onSelect={handleTabChange}
//           className="mb-3"
//           id="login-tabs"
//         >
//           <Tab eventKey="otp" title="Login with OTP">
//             <p>Enter your email and click send OTP to receive an OTP.</p>
//           </Tab>

//           <Tab eventKey="password" title="Login with Password">
//             <div className="form-group pos_relative mt-3">
//               <label>
//                 Password <span className="text-danger">*</span>
//               </label>
//               <div className="input-group">
//                 <input
//                   type={showPassword ? 'text' : 'password'}
//                   value={password}
//                   onChange={e => setPassword (e.target.value)}
//                   className="form-control"
//                   placeholder="Enter your Password"
//                 />
//                 <div className="input-group-append">
//                   <button
//                     type="button"
//                     className="btn btn-outline-secondary"
//                     onClick={() => setShowPassword (!showPassword)}
//                   >
//                     {showPassword
//                       ? <i className="fa fa-eye-slash" />
//                       : <i className="fa fa-eye" />}
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </Tab>
//         </Tabs>
// 		<label>
// 		<FormCheck
// 			type="checkbox"
// 			id={`checkbox-permanent`}
// 			label="Remember me"
// 			// checked={formValues.mailing_address === 1 ? true : false}
// 			// onChange={e => {
// 			// handleInputChange ('mailing_address', e.target.checked === true ? 1 : 0);
// 			// }}
// 		/>
// 		<Link to={`${ROUTE_BASE_URL}/forgot-password`}>Forgot username?</Link>
// 		</label>

//         <button onClick={sendOtp} className="btn btn-outline-primary btn-block">
//           {activeTab === 'otp' ? 'Send OTP' : 'Login'}
//         </button>
// 		<p><Link to={'/'}>Need help?</Link> Contact support</p>
//       </div>
//     </div>
//   </div>
//   <div id="particles-js" />
// </div>

//       ) : (
//         <OtpVerify adminId={adminId} />
//       )}
//     </>
//   );
// }
